import { createUseStyles } from 'react-jss';
const useComboboxStyles = createUseStyles((theme) => ({
    comboboxContainer: {
        position: 'relative',
        width: '100%'
    },
    inputContainer: {
        display: 'flex',
        gap: '0.5rem',
        padding: '0rem 0.5rem',
        borderRadius: '0.5rem',
        border: '1px solid #e0e0e0',
        backgroundColor: 'white',
        '&[data-open="true"]': {
            borderBottomLeftRadius: '0rem',
            borderBottomRightRadius: '0rem'
        },
        overflowX: 'hidden'
    },
    comboboxInput: {
        width: '100%',
        border: 'none',
        display: 'inline-block',
        backgroundColor: 'transparent',
        paddingTop: '0.375rem',
        paddingBottom: '0.375rem',
        paddingLeft: '0.125rem',
        paddingRight: '0.125rem',
        fontSize: '0.875rem',
        lineHeight: '1.5rem',
        outline: 'none',
        whiteSpace: 'nowrap',
        overflow: 'hidden !important',
        textOverflow: 'ellipsis',
        '&[disabled]': {
            cursor: 'not-allowed',
            color: theme.colors.grey[2]
        }
    },
    comboboxIconsContainer: {
        paddingRight: '0.5rem',
        display: 'flex',
        gap: '0.25rem',
        fontSize: '0.875rem'
    },
    comboboxButton: {
        paddingLeft: '0.25rem',
        paddingRight: '0.25rem',
        border: 'none',
        backgroundColor: 'transparent',
        cursor: 'pointer',
        '&[disabled]': {
            cursor: 'not-allowed'
        }
    },
    comboboxOptions: {
        position: 'absolute',
        marginTop: '0rem',
        display: 'flex',
        flexDirection: 'column',
        left: 0,
        right: 0,
        borderRadius: '0rem 0rem 0.5rem 0.5rem',
        borderLeft: '1px solid #e0e0e0c9',
        borderRight: '1px solid #e0e0e0c9',
        borderBottom: '1px solid #e0e0e0c9',
        borderTop: 'none',
        backgroundColor: 'white',
        boxShadow: '0 1px 2px rgba(0, 0, 0, 0.05)',
        padding: '0.25rem',
        zIndex: 50
    },
    comboboxOption: {
        padding: '0.5rem',
        borderRadius: '0.5rem',
        listStyleType: 'none',
        position: 'relative',
        cursor: 'pointer',
        display: 'flex',
        gap: '0.25rem',
        alignItems: 'center',
        '&[data-focus]': {
            backgroundColor: theme.colors.grey[5]
        },
        '& .checkIcon': {
            visibility: 'hidden',
            paddingBottom: '0.125rem'
        },
        '&[data-selected] .checkIcon': {
            visibility: 'visible'
        }
    }
}));
export default useComboboxStyles;
